import script from "./button-group.vue?vue&type=script&lang=ts&setup=true"
export * from "./button-group.vue?vue&type=script&lang=ts&setup=true"

import "./button-group.vue?vue&type=style&index=0&id=8c720684&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c720684"]])

export default __exports__